import React from "react";
import {Container, createTheme, CssBaseline, ThemeProvider} from "@mui/material";
import Typography from "@mui/material/Typography";
import {Notifications} from "@mui/icons-material";

const theme = createTheme({
    typography: {
        fontFamily: [
            'Open Sans Condensed',
            'sans-serif'
        ].join(',')
    },
});

export const NotificationHeader = () => {
    return (
        <ThemeProvider theme={theme}>
            <div style={{ textAlign: 'center'}}>
                <CssBaseline />
                <Container maxWidth="sm" sx={{ mt: '3rem'}}>
                <Typography component="div" variant="h4" sx={{ mb: '1rem', textTransform: 'uppercase'}} color={'info'}>
                    Notification Manager <Notifications fontSize={'large'} color={'info'}/>
                </Typography>
                </Container>
            </div>
        </ThemeProvider>
    )
}

